import {
  Divider as MantineDivider,
  type DividerProps as MantineDividerProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type DividerProps = CoreComponentProps<MantineDividerProps, 'div'>;

export function Divider({ testId, view = "all", ...rest }: DividerProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineDivider data-testid={testId} {...rest} />;
}
